<template>
  <div>
    <div
      v-if="menuDatasReady"
      class="set-list-box"
    >
      <set-list-item
        v-for="(item, key) in menuDatas"
        :key="key"
        :item-data="item"
      />
    </div>
    <div
      v-else
      class="loading"
    >
      <a-spin tip="loading" />
    </div>
  </div>
</template>
<script>
import SetListItem from './SetListItem'
import { mapState } from 'vuex'
export default {
  components: {
    SetListItem
  },
  computed: {
    ...mapState('config/setlist', ['menuDatas', 'menuDatasReady'])
  },
  methods: {
  }
}
</script>
<style lang="scss" scoped>
.set-list-box::v-deep {
  padding-top: 8px;
}
</style>
